import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useTheme from '@mui/material/styles/useTheme';
import { Grid, Box, Button, Typography } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
//
import { Spinner } from "/@/app/components/Spinner";

export const FloatingSaveControls = ({ saveState, onReset, onSave, }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [resetConfirm,setResetConfirm]=useState(false);

    return (
<>
<Dialog open={resetConfirm}>
<DialogTitle>{t('Подтвердите действие')}</DialogTitle>
<DialogContent>
<Box sx={{mb:2}}><Typography sx={{fontSize:'1.2rem'}}>{t('Сбросить несохранённые данные ?')}</Typography></Box>
</DialogContent>
<DialogActions>
<Button onClick={e=>setResetConfirm(false)}>{t('Отмена')}</Button>
<Button onClick={e=>{setResetConfirm(false);onReset();}} variant="contained">{t('button-reset')}</Button>
</DialogActions>
</Dialog>
        <Box
            sx={{
                position: 'fixed',
                width: '100%',
                zIndex: (theme) => theme.zIndex.drawer - 1,  // keep below the main drawer
                display: 'flex',
                justifyContent: {
                    xs: 'flex-end',
                    lg: 'center', // when right sidebar is shown
                },
                top: theme.custom.appBarHeight, // Always on top, because device keyboard overlaps the buttons
                pt: 2,
                right: theme => theme.spacing(3),
                pointerEvents: 'none',

            }}
        >

            <Grid container spacing={2} sx={{
                width: "auto",
                display: saveState === "unsaved" ? "flex" : "none",
                alignItems: "center",
                pointerEvents: 'auto',

            }}>
                <Grid item>
                    <Button
                        size="large"
                        variant="outlined"
                        onClick={() => { setResetConfirm(true) }}
                        sx={{
                            padding: "10px 20px",
                            backgroundColor: "rgba(255,255,255,0.8)",
                            borderRadius: "20px",
                            fontSize: "1em",
                            boxShadow: "0 0 10px rgba(0,0,0,0.5)",
                        }}
                    >{t('button-reset')}</Button>
                </Grid>
                <Grid item>
                    <Button
                        size="large"
                        variant="contained"
                        onClick={() => {onSave();}}
                        sx={{
                            padding: "18px 35px",
                            borderRadius: "30px",
                            fontSize: "1.3em",
                            boxShadow: "0 0 10px rgba(0,0,0,0.5)",
                        }}
                    >{t('button-save')}</Button>
                </Grid>
            </Grid>


            <Box
                sx={{
                    // use 'display' also, to avoid unclickable area
                    display: saveState === "saving" ? "block" : "none",
                    textAlign: 'center',
                }}
            >
                {/* 'hidden' prop is to ensure delay on each show */}

                <Typography variant="body1" sx={{
                    backgroundColor: theme.palette.warning.main,  // make it clearly visible
                    color: 'white',
                    padding: '10px 20px',
                    borderRadius: '20px',
                    boxShadow: "0 0 10px rgba(0,0,0,0.5)",
                    display: "flex",
                    flexFlow: "row wrap",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                }}>
                    <Spinner delay={1000} hidden={saveState !== "saving"} size={20} sx={{
                        color: "white",
                        display: "inline-block",
                    }} />
                    {t('Сохранение')} ...
                </Typography>
            </Box>
        </Box>
</>
    )
};
